import { call, select } from 'redux-saga/effects';
import { deleteShopper as deleteShopperAda } from '@bitComponents/adabyron/register';

const contextStore = state => state.context.data;

export function* deleteShopper() {
  const context = yield select(contextStore);
  const response = yield call(deleteShopperAda, context);
  return response;
}
